const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const id = value => typeof value === 'string' && value.length > 0;
const optionalText = value => value == null || typeof value === 'string';
const reference = value => value == null || id(value) || record(value) && id(value._id);
export const isRelationshipPoint = value => value == null || record(value)
  && value.type === 'Point' && Array.isArray(value.coordinates)
  && value.coordinates.length === 2 && value.coordinates.every(Number.isFinite)
  && Math.abs(value.coordinates[0]) <= 180 && Math.abs(value.coordinates[1]) <= 90;
export const isRelationshipMember = value => record(value) && id(value._id)
  && value.verificationCode == null
  && !['password', 'refreshToken', 'resetPasswordToken', 'resetPasswordExpires', 'emailVerificationCode', 'emailVerificationExpires'].some(field => Object.hasOwn(value, field))
  && typeof value.firstName === 'string' && typeof value.lastName === 'string'
  && ['profilePicture', 'bahaiId', 'status'].every(field => optionalText(value[field]))
  && ['userId', 'family', 'household', 'community'].every(field => reference(value[field]));
export const isLineageHousehold = value => record(value) && id(value._id)
  && ['address', 'displayName', 'placeId'].every(field => optionalText(value[field]))
  && isRelationshipPoint(value.location)
  && Array.isArray(value.members) && value.members.every(isRelationshipMember)
  && (value.lineages === undefined || Array.isArray(value.lineages) && value.lineages.every(reference))
  && ['community', 'primaryContact', 'venueApprover'].every(field => reference(value[field]))
  && ['isActive', 'acceptVenueRequest', 'allowRepeatResidenceRequests'].every(field => value[field] === undefined || typeof value[field] === 'boolean');
